import path from "path";

import { WellKnownDirectories } from "../WellKnownDirectories";

export function extractGFV(gfv: string): { group: string; format: string; version: string } {
    const version = gfv.slice(-2);
    const format = gfv.slice(-5, -2);
    const group = gfv.slice(0, -5);

    return { group: group, format: format, version: version };
}

export function extractGFVPath(gfv: string) {
    const { format, group } = extractGFV(gfv);
    const repositoryRoot = path.join(
        __dirname,
        "..",
        "..",
        "..",
        WellKnownDirectories.ExternFormsDefaultCheckoutDirectory
    );

    const formPath = path.join(
        repositoryRoot,
        WellKnownDirectories.FormsDirectory,
        group,
        format,
        gfv,
        WellKnownDirectories.CandySubdirectoryName
    );
    const farmPath = path.join(repositoryRoot, WellKnownDirectories.CandyFarmDirectory);

    return { formPath: formPath, farmPath: farmPath };
}

export function extractGFVPathFromCandyFarmPath(candyFarmPath: string, gfv: string) {
    const { format, group } = extractGFV(gfv);
    return path.join(
        candyFarmPath,
        "..",
        WellKnownDirectories.FormsDirectory,
        group,
        format,
        gfv,
        WellKnownDirectories.CandySubdirectoryName
    );
}

export function extractGfvFromFormPath(formPath: string): string {
    const regexp = new RegExp(
        `([\\/\\\\](?<gfv1>\\d{6,})[\\/\\\\]${WellKnownDirectories.CandySubdirectoryName})|(((\\.farm)|(${WellKnownDirectories.TestFarmDir}))[\\/\\\\]forms[\\/\\\\](?<gfv2>\\d{6,}))`
    );
    const match = regexp.exec(formPath);
    const gfv = match?.groups?.["gfv1"] ?? match?.groups?.["gfv2"];
    if (gfv) {
        return gfv;
    }
    // Ошибка не долетает до консоли при работе с сервисранера. Поэтому доп. консолька
    // eslint-disable-next-line no-console
    console.trace(`[Error] Unable to determine gfv from path: ${formPath}`);
    throw new Error(`Unable to determine gfv from path: ${formPath}`);
}
